module.exports = __webpack_public_path__ + "img/DE00036.c4e15302.svg";